<template>
  <div
    v-if="prepaidMin"
    class="col text-center pb-1">
    <div
      v-if="!condense"
      class="my-3">
      <h6>Prepaid Freight</h6>
    </div>
    <small
      v-else
      style="line-height: 16px;">
      Prepaid: <strong>{{ numeral(prepaidMin).format('$0,0.00') }}</strong>
    </small>
    <div
      class="progress shadow-sm"
      :class="condense ? 'condense-progress' : 'standard-progress'">
      <div
        class="progress-bar bg-info"
        role="progressbar"
        :style="percentStyle">
        <!-- Inside Text -->
        <strong
          v-if="cartAmount >= prepaidMin"
          class="animate__animated animate__bounceIn animate__faster">
          <i class="fa fa-check-circle"/>
          Acheived!
        </strong>
        <strong v-else>
          {{ numeral(percent).format('0.0%') }}
        </strong>
      </div>
    </div>
    <div v-if="cartAmount < prepaidMin && !condense">
      {{ numeral(cartAmount).format('$0,0.00') }} / <strong>{{ numeral(prepaidMin).format('$0,0.00') }}</strong>
    </div>
  </div>
</template>

<script setup>
  import {computed} from 'vue';

  // Initialize
  const props = defineProps(['mfg', 'company', 'cart', 'cartAmount', 'cartVendorMatch', 'dropshipCart', 'condense'])

  // Computed
  const prepaidMin = computed(()=>{
    const min = _.find(props.mfg.details.vendor_mins, v => v.company == props.company && v.minFunction == 'prepaid')
    return parseFloat(min?.minValue) || null
  })

  // Dollar compar var%
  const percent = computed(()=>{
    if(props.dropshipCart && props.cartVendorMatch){
      const value = (props.cartAmount / prepaidMin.value)
      return value > 1 ? 1 : value
    }
    return null
  })

  // Cart amount vs Vendor min dollars used to drive progress bar
  const percentStyle = computed(()=>{
    return {
      'width': (percent.value * 100) + '%'
    }
  })
</script>

<style scoped>
  .condense-progress{
    width: 100%;
    position: relative;
    margin: 0px 5px;
    height: 20px;
  }
  
  .standard-progress{
    height: 30px;
  }
</style>